<template>
    <Transition name="pop">
        <div class="pop" v-if="state.show">
            <div class="content">
                <span class="close" @click="state.show = false">
                    <svg
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="3135"
                        width="200"
                        height="200"
                    >
                        <path
                            d="M461.843747 512 10.406151 963.437601C-3.37504 977.218792-3.412751 999.712215 10.437524 1013.562479 24.384355 1027.509306 46.729466 1027.42679 60.562404 1013.593849L512 562.156248 963.437596 1013.593849C977.218787 1027.37504 999.712218 1027.412745 1013.562476 1013.562479 1027.509306 999.615652 1027.426786 977.270542 1013.593849 963.437601L562.156253 512 1013.593849 60.562399C1027.37504 46.781208 1027.412751 24.287786 1013.562476 10.43752 999.615645-3.509307 977.270534-3.42679 963.437596 10.406151L512 461.843752 60.562404 10.406151C46.781213-3.37504 24.287782-3.412745 10.437524 10.43752-3.509306 24.384347-3.426786 46.729458 10.406151 60.562399L461.843747 512 461.843747 512Z"
                            fill="#ffffff"
                            p-id="3136"
                        ></path>
                    </svg>
                </span>
                <h1>您确定提交该邮寄地址？</h1>
                <ul class="detail">
                    <li><span>姓名：</span>{{ state.info.name }}</li>
                    <li><span>手机号码：</span>{{ state.info.phone }}</li>
                    <li><span>身份证号：</span>{{ state.info.cardid }}</li>
                    <li><span>邮寄地址：</span>{{ state.info.address }}</li>
                </ul>
                <ul class="btns-wrapper">
                    <li @click="state.show = false">取消</li>
                    <li @click="submitEvent">确定</li>
                </ul>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { reactive, inject } from "vue";
import { SubmitAddress } from "../../../api";

const state = reactive({
    show: false,
    info: {}
});

const addressRef = inject("addressRef");
const submitEvent = async () => {
    const res = await SubmitAddress(
        state.info.name,
        state.info.cardid,
        state.info.phone,
        state.info.address
    );
    if (res) {
        state.show = false;
        CsLib.alert("邮寄地址提交成功！", 1200, "success");
        addressRef.value.Detail(state.info);
    }
};

defineExpose({
    Show: (info) => {
        state.show = true;
        state.info = info;
    }
});
</script>

<style lang="scss" scoped>
.detail {
    margin-bottom: 24px;
    li {
        margin-bottom: 10px;
        display: flex;
        span {
            width: 94px;
        }
    }
}
.btns-wrapper {
    display: flex;
    justify-content: center;
    li {
        width: 140px;
        height: 46px;
        margin: 0px 16px;
        text-align: center;
        line-height: 46px;
        color: #fff;
        cursor: pointer;
        &:nth-of-type(1) {
            background-color: #808080;
        }
        &:nth-of-type(2) {
            background: #337ab7;
            &:hover {
                background: #23527c;
            }
        }
    }
}
</style>
